module.exports = __webpack_public_path__ + "static/media/grand_mum_walk02.9e41b2c4.png";